









import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AppCopyright extends Vue {
  get coyrightYear() {
    return new Date().getFullYear()
  }
}
